import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider as DescopeAuthProvider } from '@descope/react-sdk';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <DescopeAuthProvider
      projectId={process.env.REACT_APP_DESCOPE_PROJECT_ID}
      baseUrl="https://api.descope.com"
      autoRefresh={true}
      sessionTokenViaCookie={false}
      persistTokens={true}
    >
      <App />
    </DescopeAuthProvider>
  </React.StrictMode>
);